/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voices_Manual_Record_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Select manual record" |
*
* @param {Voices_Manual_Record_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voices_manual_record_aria_label = /** @type {((inputs?: Voices_Manual_Record_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voices_Manual_Record_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Selectionner l'enregistrement manuel")
	if (locale === "de") return /** @type {LocalizedString} */ ("Manuelle Aufzeichnung auswählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona record manuale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите запись, записанную вручную.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccionar registro manual")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择手动记录")
	if (locale === "ja") return /** @type {LocalizedString} */ ("手動記録を選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मैन्युअल रिकॉर्ड चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione registro manual")
	return /** @type {LocalizedString} */ ("Select manual record")
});